module.exports = __webpack_public_path__ + "static/img/sanya-municipal-hospital.4d338af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/sanya-municipal-hospital.png
// module id = VHv6
// module chunks = 1 2